export function money(
  n: number,
  currency: string = "MXN",
  locale: string = "es-MX"
) {
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(
    n
  );
}

// Atajo opcional si te gusta tenerlo explícito:
export const moneyMXN = (n: number) => money(n, "MXN", "es-MX");
